import React from 'react';
import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history/History_of_Sci_&_Tech_-_Development_of_Computers_and_the_Internet.png';

function HistoryPageComputersInternetGo() {
  return (
    <QuizPage
      title="History: Development of Computers and the Internet"
      subTopic="Development of Computers and the Internet"
      backgroundImage={historyImage}
      returnPath="/History-Computers-Internet"
    />
  );
}

export default HistoryPageComputersInternetGo;
